import { render, staticRenderFns } from "./LegalDocumentsList.vue?vue&type=template&id=10b4169c&"
import script from "./LegalDocumentsList.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports